import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const EmailVerify = () => {
    const { token } = useParams();
    const [ success, setSuccess ] = useState(null);
    const [ message, setMessage ] = useState(null);
    useEffect(() => {
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_BASE_URL}/user/email-verify`,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify({
                token: token
            }),
        }).then(res => {
            setSuccess(true);
            setMessage(res.data.message);
        }).catch(err => {
            setSuccess(false);
            setMessage(err.response.data.message || "Error 500");
        });
    }, []);
    return (
        <>
            {success ?
                <div>
                    <center>
                        <h1>{message}</h1>
                    </center>
                </div>
                :
                <div>
                    <center>
                        <h1>{message}</h1>
                    </center>
                </div>
            }
        </>
    );
};

export default EmailVerify;